import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardStats from "components/Cards/CardStats.js";
import { fetchBlogs } from "store/blogSlice";
import { fetchFaqs } from "store/faqSlice";
import { fetchTeams } from "store/teamSlice";

export default function HeaderStats() {
  const dispatch = useDispatch();
  const { items: blogs, loading: blogLoading } = useSelector((s) => s.blogs);
const { items: faqs, loading: faqLoading } = useSelector((s) => s.faqs);
const { items: teams, loading: teamLoading } = useSelector((s) => s.teams);


useEffect(() => {
dispatch(fetchBlogs());
dispatch(fetchFaqs());
dispatch(fetchTeams());
// dispatch(fetchDashboard()); // optional if you still want other stats
}, [dispatch]);


const loading = blogLoading || faqLoading || teamLoading;

  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL TEAM"
                  statTitle={loading ? "..." : teams.length.toString()}
                  statIconName="fas fa-video"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL BLOGS"
                  statTitle={loading ? "..." : blogs.length.toString()}
                  statIconName="fas fa-users"
                  statIconColor="bg-orange-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL FAQ"
                  statTitle={loading ? "..." : faqs.length.toString()}
                  statIconName="fas fa-dollar-sign"
                  statIconColor="bg-emerald-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
